import React from 'react';
import { CustomIcon } from '../CustomIcons';
export function StoreBadges({
  onClick,
  className = ''
}: {
  onClick?: () => void;
  className?: string;
}) {
  return <div className={`grid grid-cols-2 gap-3 sm:flex sm:gap-4 ${className}`} data-id="element-103" data-mp="5uywkrovgxxq">
      <button onClick={onClick} className="group flex min-h-[56px] items-center gap-2.5 rounded-2xl bg-brand-navy px-3 text-left text-white shadow-soft transition-all duration-200 hover:-translate-y-0.5 hover:shadow-float active:scale-[0.98] sm:px-5" data-id="element-104" data-mp="asqqtsczow53">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-white/10 transition-colors group-hover:bg-white/20 sm:h-10 sm:w-10" data-id="element-105" data-mp="3j928ni8ubc0x">
          <CustomIcon name="card" size={18} data-id="element-106" data-mp="3sxtx3geoze73" />
        </span>
        <span className="min-w-0" data-id="element-107" data-mp="3szeq31lcyp2u">
          <span className="block text-[8px] font-extrabold uppercase tracking-[.1em] text-blue-200 sm:text-[9px]" data-id="element-108" data-mp="2vifzfnn3nlpc">Explore the</span>
          <span className="block truncate text-xs font-extrabold sm:text-sm" data-id="element-109" data-mp="30grag1p4s295">VE Bank app</span>
        </span>
      </button>
      <button onClick={onClick} className="group flex min-h-[56px] items-center gap-2.5 rounded-2xl border border-slate-200 bg-white px-3 text-left text-brand-navy shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md active:scale-[0.98] sm:px-5" data-id="element-110" data-mp="k0fjflr2wbl4">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-brand-cloud text-brand-cobalt transition-colors group-hover:bg-blue-50 sm:h-10 sm:w-10" data-id="element-111" data-mp="68r99o0e3x6s">
          <CustomIcon name="scan" size={18} data-id="element-112" data-mp="3sghbnp5sqmbs" />
        </span>
        <span className="min-w-0" data-id="element-113" data-mp="3sj3i1lgyavsf">
          <span className="block text-[8px] font-extrabold uppercase tracking-[.1em] text-brand-slate sm:text-[9px]" data-id="element-114" data-mp="3ngw4irgh37nz">Open the</span>
          <span className="block truncate text-xs font-extrabold sm:text-sm" data-id="element-115" data-mp="3jhncps4ztjv2">Live prototype</span>
        </span>
      </button>
    </div>;
}